import { createTranslateLoader } from '../shared/utilities/createTranslateLoader';
var ɵ0 = createTranslateLoader;
var DialogsModule = /** @class */ (function () {
    function DialogsModule() {
    }
    return DialogsModule;
}());
export { DialogsModule };
export { ɵ0 };
